import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiHome, FiTool, FiGrid, FiLayers, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const servicesData = [
  {
    title: "Hochbau",
    icon: FiHome,
    image: "https://media-manager-c.questera.ai/greta-media/b3858647681825aecd68df56d8217cb5094538977d896e84f508e759d2eeedf7b0dda9d7934361b5765cf6718803dd25/images/aW1hZ2UvanBlZw==/aad0ad874867a220700047e611e429fa.jpg",
    description: "Von Rohbauarbeiten über Anbauten bis hin zur kompletten Sanierung. Wir sorgen für die statische Sicherheit und den fachgerechten Mauerwerksbau Ihrer Immobilie."
  },
  {
    title: "Tiefbau",
    icon: FiTool,
    image: "https://media-manager-c.questera.ai/greta-media/b3858647681825aecd68df56d8217cb5094538977d896e84f508e759d2eeedf7b0dda9d7934361b5765cf6718803dd25/images/aW1hZ2UvanBlZw==/f109a70b72a8e4a59f7ab5bee01eccd8.jpg",
    description: "Erdaushub, Kanalanschlüsse und professionelle Entwässerungssysteme. Wir schaffen die solide Basis für jedes Bauwerk unter der Erdoberfläche."
  },
  {
    title: "Pflasterbau",
    icon: FiGrid,
    image: "https://media-manager-c.questera.ai/greta-media/b3858647681825aecd68df56d8217cb5094538977d896e84f508e759d2eeedf7b0dda9d7934361b5765cf6718803dd25/images/aW1hZ2UvanBlZw==/538e2bea902e8bce131d02fc2ff2548d.jpg",
    description: "Fachgerechte Verlegung von Pflastersteinen für Einfahrten, Terrassen und Wege. Wir kombinieren Langlebigkeit mit ansprechender Optik im Außenbereich."
  },
  {
    title: "Putz & Stuck",
    icon: FiLayers,
    image: "https://media-manager-c.questera.ai/greta-media/b3858647681825aecd68df56d8217cb5094538977d896e84f508e759d2eeedf7b0dda9d7934361b5765cf6718803dd25/images/aW1hZ2UvanBlZw==/662114ade71509832bc769a11829c3ce.jpg",
    description: "Hochwertige Innen- und Außenputzarbeiten. Wir verleihen Ihren Wänden die perfekte Oberfläche, schützen die Bausubstanz und sorgen für ein gesundes Raumklima."
  }
];

const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-slate-900 py-24 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]"></div>
        </div>
        <div className="container mx-auto px-6 lg:px-12 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-8 uppercase tracking-tight">
              Unsere <span className="text-red-500">Leistungen</span>
            </h1>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="w-24 h-2 bg-red-800 rounded-full mx-auto mb-8"
            ></motion.div>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto font-light leading-relaxed"
            >
              Präzision im Detail, Stabilität im Ganzen. Entdecken Sie unser breites Spektrum an baulichen Lösungen.
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
            {servicesData.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7, delay: index * 0.1 }}
                className="group relative bg-slate-50 rounded-[2rem] overflow-hidden border border-slate-100 shadow-sm hover:shadow-2xl transition-all duration-500"
              >
                <div className="relative h-80 overflow-hidden">
                  <motion.img
                    whileHover={{ scale: 1.1 }}
                    transition={{ duration: 1.5 }}
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-6 left-6 bg-red-800 text-white p-4 rounded-2xl shadow-xl">
                    <SafeIcon icon={service.icon} className="text-3xl" />
                  </div>
                </div>
                <div className="p-10">
                  <h3 className="text-3xl font-bold text-slate-900 mb-4 group-hover:text-red-700 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 text-lg leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="pb-32 px-6">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="bg-red-800 rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden shadow-2xl"
          >
            <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:20px_20px]"></div>
            <div className="relative z-10">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">Bereit für Ihr Projekt?</h2>
              <p className="text-red-100 text-xl mb-12 max-w-2xl mx-auto">
                Lassen Sie uns gemeinsam Großes erschaffen. Wir beraten Sie kompetent und unverbindlich.
              </p>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-3 bg-white text-red-800 px-10 py-5 rounded-2xl font-bold text-xl hover:bg-slate-100 transition-all shadow-xl hover:-translate-y-1"
              >
                Kontakt aufnehmen <SafeIcon icon={FiArrowRight} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Services;